import { Component, OnDestroy, OnInit } from "@angular/core";

@Component({
  templateUrl: "./ba.component.html"
})
export class BAComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit() {}

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./client/app/internal/accmgr/ba/Home/ba.component.ts